import { isFRQ } from 'legacy/src/utility/progressHelpers';

const studentOptionalPracticeQuiz = ({
  showStudentPracticeResultsFlag,
  isStudent,
  isPreApSubject,
}) => {
  const isApStudentAndFlag =
    isStudent && !isPreApSubject && showStudentPracticeResultsFlag;
  const isApTeacherAndFlag =
    !isStudent && !isPreApSubject && showStudentPracticeResultsFlag;

  const containsFRQQuestionTypesOnly = (questionTypes) =>
    !questionTypes.some((e) => e !== 'questions/free_response');

  const displayAssignmentLinkStudent = (
    containsSecureQuestions,
    questionTypes,
    awaitingScoring,
  ) =>
    isApStudentAndFlag &&
    !containsSecureQuestions &&
    containsFRQQuestionTypesOnly(questionTypes) &&
    awaitingScoring;

  const displayAssignmentLinkTeacher = (
    containsSecureQuestions,
    questionTypes,
    awaitingScoring,
  ) =>
    !(
      isApTeacherAndFlag &&
      !containsSecureQuestions &&
      containsFRQQuestionTypesOnly(questionTypes) &&
      awaitingScoring
    );

  const hideStudentOptionalPracticeQuizDetails = (
    isSecure,
    questions,
    awaitingScoring,
  ) =>
    isApStudentAndFlag &&
    !isSecure &&
    !!!questions.some((question) => !isFRQ(question)) &&
    awaitingScoring;

  return {
    isApStudentAndFlag,
    displayAssignmentLinkStudent,
    displayAssignmentLinkTeacher,
    hideStudentOptionalPracticeQuizDetails,
  };
};

export default studentOptionalPracticeQuiz;
